import './App.css';
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import React from "react";
import Home from "./components/Home";
import ManualBrowser from './components/ManualBrowser';


function App() {
  const location = useLocation()
  const path= location.pathname === '/' ? '/manual/main' : location.pathname
  return (
    <div className="App">
      <Routes>
        <Route path='/manual/main' element={<Home />}></Route>
        <Route exact path='/manual/:manual/:page?' element={<ManualBrowser />}></Route>
        <Route path="/" element={<Navigate to={path} />} />
        <Route path="/manual/guides" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;
